export default {
  SUPER_ADMIN: 1,
  TENANT_ADMIN: 2,
  READ_ONLY: 3,
};
